import './dist/index';

const SDK = window.SDK;

export default SDK;
